import { action } from 'typesafe-actions'
import { FooterActionTypes } from './types'

export const fetchPhonesRequest = () =>
  action(FooterActionTypes.FETCH_PHONES_REQUEST)

export const fetchPhonesSuccess = (data: { data: any }) =>
  action(FooterActionTypes.FETCH_PHONES_SUCCESS, { data })

export const fetchPhonesFail = (message: string) =>
  action(FooterActionTypes.FETCH_PHONES_FAIL, message)
